<template>
  <div v-if="type && component !== 'unknow' && shouldShow">
    <div :class="{'w-100 float-none m-0': type.code.match(/OBJECT/),'m-3': !type.code.match(/OBJECT/) }"
         class="property-manager flex-grow-1">
      <template v-if="isDisabled">
        <div class="d-flex justify-content-between">
          <label class="fw-bolder text-muted">&nbsp; {{ propName }}</label>
        </div>
        <div class="form-control bg-light text-muted cursor-not-allowed" v-b-tooltip.hover :title="disabledReason">
          {{ displayValue || '-' }}
        </div>
      </template>
      <template v-else>
        <div class="d-flex justify-content-between">
          <label class="fw-bolder">&nbsp; {{ propName }}</label>
        </div>
        <component :is="component" :itemUuid="itemUuid" :propertyCode="propertyCode" :isDisabled="false" @propertyUpdated="onUpdate"></component>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import PropertyText from "@/views/Income/Avenant/Components/PropertyText.vue";
import PropertyPhoto from "@/views/Income/Avenant/Components/PropertyPhoto.vue";
import PropertyRadio from "@/views/Income/Avenant/Components/PropertyRadio.vue";
import PropertyDate from "@/views/Income/Avenant/Components/PropertyDate.vue";
import PropertyNumber from "@/views/Income/Avenant/Components/PropertyNumber.vue";
import PropertyAmount from "@/views/Income/Avenant/Components/PropertyAmount.vue";
import PropertyBoolean from "@/views/Income/Avenant/Components/PropertyBoolean.vue";
import PropertyPackCategory from "@/views/Income/Avenant/Components/PropertyPackCategory.vue";
import {helper} from "@/services/Helper";
import {getPropertyVisibility} from "@/services/ItemFunction";

@Component({
  components: {PropertyPackCategory, PropertyBoolean, PropertyAmount, PropertyNumber, PropertyDate, PropertyRadio, PropertyPhoto, PropertyText}
})
export default class AvenantPropertyManager extends Vue {

  @Prop() itemUuid!: string
  @Prop() propertyCode!: string
  @Prop() type!: any

  get item() {
    return this.$store.getters["contractStore/getEntity"]('items', this.itemUuid)
  }

  get model() {
    if (!this.item) return null
    const itemType = this.$store.state.contractStore.itemTypes[this.item.modelCode]
    if (!itemType?.properties) return null
    return (Object.values(itemType.properties) as any[]).find((pm: any) => pm.code === this.propertyCode) || null
  }

  get propName() {
    return this.model?.name || this.propertyCode
  }

  get component() {
    if (!this.type?.code) return 'unknow'
    if (this.type.code.match(/TEXT|CONTACT|EMAIL|CAR_BRAND|CAR_MODEL/)) return 'PropertyText'
    if (this.type.code.match(/PHOTO/)) return 'PropertyPhoto'
    if (this.type.code === 'BOOLEAN') return 'PropertyBoolean'
    if (this.type.code.match(/RADIO|CHECKBOX/)) return 'PropertyRadio'
    if (this.type.code.match(/DATE|DATETIME/)) return 'PropertyDate'
    if (this.type.code.match(/NUMBER/)) return 'PropertyNumber'
    if (this.type.code.match(/AMOUNT/)) return 'PropertyAmount'
    if (this.type.code === 'PACK_CATEGORY') return 'PropertyPackCategory'
    if (this.type.code.match(/OBJECT/)) return 'unknow'
    return 'unknow'
  }

  get isDisabled() {
    const avenantType = this.$store.state.contractStore.avenantType
    if (!avenantType) return false
    if (!avenantType.allowEdit) return true
    if (avenantType.allowedEdition?.length > 0) {
      return !avenantType.allowedEdition.includes(this.propertyCode)
    }
    return false
  }

  get isVisible() {
    if (!this.item || !this.model) return false
    return getPropertyVisibility(this.item, this.model)
  }

  get shouldShow() {
    if (!this.isVisible) return false
    if (!this.isDisabled) return true
    return (this as any).hasRole('ROLE_ADMIN')
  }

  get disabledReason() {
    const avenantType = this.$store.state.contractStore.avenantType
    if (!avenantType?.allowEdit) return "L'édition n'est pas autorisée pour ce type d'avenant"
    return "Cette propriété n'est pas modifiable pour ce type d'avenant"
  }

  get displayValue() {
    const value = this.item?.properties?.[this.propertyCode]
    if (helper.empty(value)) return '-'
    if (this.type?.code === 'RADIO') {
      const choice: any = Object.values(this.model?.choices || {}).find((c: any) => c.code === value)
      return choice?.label || value
    }
    if (this.type?.code === 'BOOLEAN') {
      return value === true || value === 'true' ? 'Oui' : 'Non'
    }
    return value
  }

  initalValue: any = null

  mounted() {
    this.initalValue = this.item?.properties?.[this.propertyCode]
  }

  onUpdate() {
    const currentValue = this.item?.properties?.[this.propertyCode]
    if (this.initalValue !== currentValue) {
      this.initalValue = currentValue
      this.$emit('propertyUpdated', {code: this.propertyCode, itemUuid: this.itemUuid})
    }
  }
}
</script>
